import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { ErrorBoundary } from '@betterment/shared-components';
import { Route, Routes, useMatch } from 'react-router-dom';

import { TermsAndAgreementsStep } from './steps/TermsAndAgreementsStep';
import { UpdateUserLevelSettingsStep } from './steps/UpdateUserLevelSettingsStep';

import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { urlBuilder } from '../Shared/urlBuilder';

export default function Controller() {
  const match = useMatch(`${urlBuilder.appEditUserLevelSettings()}/*`);
  const returnToPath = urlBuilder.getLegalAccounts.absolute();

  return (
    <ErrorBoundary>
      <IdempotencyProviderWithFeatureRegistry featureName="editUserLevelSettings">
        <FlowContextProvider basePath={match!.pathnameBase} routePath="" returnToPath={returnToPath}>
          <Routes>
            <Route
              path="/update_settings"
              element={
                <StepWrapper name="update_settings">
                  {stepProps => <UpdateUserLevelSettingsStep {...stepProps} />}
                </StepWrapper>
              }
            />
            <Route
              path="/terms_and_agreements"
              element={
                <StepWrapper name="terms_and_agreements">
                  {stepProps => <TermsAndAgreementsStep {...stepProps} />}
                </StepWrapper>
              }
            />
          </Routes>
        </FlowContextProvider>
      </IdempotencyProviderWithFeatureRegistry>
    </ErrorBoundary>
  );
}
